<template>
  <div class="app-col" :class="classes">
    <slot/>
  </div>
</template>

<script>
  export default {
    name: "AppCol",
    props: {
      cols: {
        default: null,
      },
      xs: {
        default: null,
      },
      sm: {
        default: null,
      },
      md: {
        default: null,
      },
      lg: {
        default: null,
      },
      xl: {
        default: null,
      }
    },
    computed: {
      classes(){
        let classes = [];
        let colClass = "app-col";

        if(this.cols !== null){
          classes.push(`${colClass}--${this.cols}`);
        }

        if(this.xs !== null){
          classes.push(`${colClass}-xs--${this.xs}`);
        }

        if(this.sm !== null){
          classes.push(`${colClass}-sm--${this.sm}`);
        }

        if(this.md !== null){
          classes.push(`${colClass}-md--${this.md}`);
        }

        if(this.lg !== null){
          classes.push(`${colClass}-lg--${this.lg}`);
        }

        if(this.xl !== null){
          classes.push(`${colClass}-xl--${this.xl}`);
        }

        return classes;
      }
    }
  }
</script>

<style lang="scss">
  $breakpoints: ('xl': 1200,'lg': 992, "md": 768, "sm": 576, "xs": 476,);
  $columns: 12;


  @function col-width($i, $columns) {
    @return 100% / $columns * $i;
  }

  @mixin col-props($i, $columns, $gutter) {

    width: 100%;
    flex: 0 0 col-width($i, $columns);
    max-width: col-width($i, $columns);
  }

  @mixin columns-loop($name, $columns, $gutter) {
    $postfix: "";

    @if $name == "" {

    } @else {
      $postfix: #{$name}-;
    }

    @for $i from 0 through $columns {
      &-#{$postfix}-#{$i} {
        @include col-props($i, $columns, $gutter);
      }
    }
  }


  .app-col {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
    padding: 15px;

    @include columns-loop('', $columns, 30px);

    @each $name, $breakpoint in $breakpoints {
      @media screen and (max-width: #{$breakpoint}px) {
        @include columns-loop($name, 12, 30px);
      }
    }
  }
</style>